import { useTranslation } from "react-i18next";
import { _adr } from "../../../../address";
import { useDealer } from "../../../../tools/api";
import { switchPlanID } from "../../../../tools/services";
import { toman } from "../../../auxiliary/shop/ShopPage";
import WalletPrefactor, { useTaxPercent } from "../../../auxiliary/shop/WalletPrefactor";
import "../dc.scss";

export const DC_STEPS = ["مبلغ شارژ", "پیش فاکتور", "رسید"];
const SHOP = _adr.DCPurchase.Index + _adr.DCPurchase.Shop;

// the customer pays the charge amount (tax included); the wallet pays it minus the dealer commission.
// nothing is priced until the tax percent arrives. Also used by the summary on the first step.
export const chargeMath = (amount, tax, cccommission) => ({
	taxPrice: tax > 0 ? (amount * tax) / 100 : 0,
	total: tax > 0 ? amount : 0,
	commission: tax > 0 ? (amount * cccommission) / 100 : 0,
	walletDebit: tax > 0 ? amount - (amount * cccommission) / 100 : 0,
});

const DCPrefactor = () => {
	const [t] = useTranslation("global");
	const { completeDCPurchase } = useDealer();
	const tax = useTaxPercent();

	const invoice = (order, user) => {
		const amount = order?.chargeAmount;
		const { taxPrice, total, commission, walletDebit } = chargeMath(amount, tax, user?.cccommission);
		return {
			details: (
				<div className="list-item">
					<div className="item">
						<div className="label">مبلغ شارژ:</div>
						<div className="value">{toman(amount)}</div>
					</div>
				</div>
			),
			rows: [
				["مبلغ شارژ", amount - taxPrice],
				[`مالیات (${tax}درصد)`, taxPrice],
				["مبلغ قابل دریافت از مشتری", total],
				["مبلغ سود شما از فروش", commission],
				["مبلغ برداشت از کیف پول", walletDebit],
			],
			walletDebit,
		};
	};

	return (
		<WalletPrefactor
			title={t("directCharge.title")}
			prefix="sp"
			steps={DC_STEPS}
			simLabel="سیم‌کارت اعتباری"
			stateKey="dcCharge"
			chargePlanId={process.env.REACT_APP_PLANID_CHARGE_WALLET_DC}
			invoice={invoice}
			pay={(order) => completeDCPurchase({ msisdn: order?.msisdn, planid: switchPlanID().directCharge, chargeamount: order?.chargeAmount })}
			finalPath={SHOP + _adr.DCPurchase.Final}
			finalState={(response, order) => ({ ...response, purchase: order?.purchase || null })}
			backPath={SHOP + _adr.DCPurchase.Charge}
		/>
	);
};

export default DCPrefactor;
